import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.4618 6.21213C14.4873 6.96162 15.5 7.33637 15.5 8C15.5 8.66363 14.4873 9.03838 12.4618 9.78787L11.3322 10.2059C10.9277 10.3555 10.7254 10.4304 10.5779 10.5779C10.4304 10.7254 10.3555 10.9277 10.2059 11.3322L9.78787 12.4618C9.03838 14.4873 8.66363 15.5 8 15.5C7.33637 15.5 6.96162 14.4873 6.21213 12.4618L5.79413 11.3322C5.64446 10.9277 5.56962 10.7254 5.42209 10.5779C5.27456 10.4304 5.07232 10.3555 4.66783 10.2059L3.53821 9.78787C1.51274 9.03838 0.5 8.66363 0.5 8C0.5 7.33637 1.51274 6.96162 3.53821 6.21213L4.66783 5.79413C5.07232 5.64446 5.27456 5.56962 5.42209 5.42209C5.56962 5.27456 5.64446 5.07232 5.79413 4.66783L6.21213 3.53821C6.96162 1.51274 7.33637 0.5 8 0.5C8.66363 0.5 9.03838 1.51274 9.78787 3.53821L10.2059 4.66783C10.3555 5.07232 10.4304 5.27456 10.5779 5.42209C10.7254 5.56962 10.9277 5.64446 11.3322 5.79413L12.4618 6.21213Z" fill={color}/>
    </svg>
)

export default class IconStarSimple extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
